import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface ContractRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const ContractRefreshContext = createContext<ContractRefreshContextType | undefined>(undefined);

interface ContractRefreshProviderProps {
  children: ReactNode;
}

export const ContractRefreshProvider: React.FC<ContractRefreshProviderProps> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return (
    <ContractRefreshContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </ContractRefreshContext.Provider>
  );
};

export const useContractRefresh = () => {
  const context = useContext(ContractRefreshContext);
  if (context === undefined) {
    throw new Error('useContractRefresh must be used within a ContractRefreshProvider');
  }
  return context;
};